
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Main_Data_type_date","data-name":"Main Data type date","transform":"translate(-101.151 -539.151)","fill":"none"}},[_c('rect',{attrs:{"id":"Rectangle_9038","data-name":"Rectangle 9038","width":"14","height":"14","transform":"translate(101.151 539.151)"}}),_c('path',{attrs:{"id":"Path_21024","data-name":"Path 21024","d":"M112.924 548.341a8.08 8.08 0 00-1.93-1.393 1.2 1.2 0 00-.248-.027 1.343 1.343 0 00-.672.217l-.128.075a.8.8 0 01-.371.146.285.285 0 01-.1-.02 4.766 4.766 0 01-2.7-2.7c-.031-.1-.015-.184.093-.381l.058-.1a1.3 1.3 0 00.248-1.026 8.105 8.105 0 00-1.394-1.94 1.2 1.2 0 00-.743-.379h-.05a3.123 3.123 0 00-2.036 1.423 2.075 2.075 0 00-.065 2.127l.056.124a13.133 13.133 0 002.848 3.845 13.671 13.671 0 003.857 2.848 2.927 2.927 0 001.217.3 1.763 1.763 0 001.048-.329 3.048 3.048 0 001.4-2.046 1.2 1.2 0 00-.388-.764z","stroke":"#97a0ae","stroke-linejoin":"round","stroke-width":"1.2"}})])])
          )
        }
      }
    